/**
 * Author(s) : Alagu Bala Ganapathy A
 * Purpose : This Hooks is used to perform count down.
 */
import { useEffect, useState } from 'react';
import CalculateTime from '../utils/utils';
import { TIMER_STATE } from '../constants/header-constants';

const useCountDownTimer = (countTo, eventStartDate, eventEndDate) => {
  const countDownDate = new Date(countTo).getTime();
  const currentDate = new Date();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime()
  );

  useEffect(() => {
    if (countDown <= new Date().getTime()) {
      const interval = setInterval(() => {
        setCountDown(countDownDate - new Date().getTime());
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [countDownDate, countDown]);

  if (currentDate >= eventStartDate && currentDate < eventEndDate) {
    return [TIMER_STATE.live];
  } else if (currentDate > eventEndDate) {
    return [TIMER_STATE.afterEvent];
  } else if (currentDate < eventStartDate) {
    return CalculateTime(countDown);
  }
};

export { useCountDownTimer };
